var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBricksIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 98.426 62",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".bricks_icon_svg__a{fill:none;stroke:inherit;stroke-linecap:round;stroke-linejoin:round;stroke-width:2}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)",
    "data-svg-primary": "stroke"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "bricks_icon_svg__a",
    width: 17.143,
    height: 15.002,
    rx: 2.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "bricks_icon_svg__a",
    width: 17.143,
    height: 15.002,
    rx: 2.3,
    transform: "translate(0 29.995)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "bricks_icon_svg__a",
    width: 32.145,
    height: 15.002,
    rx: 2.3,
    transform: "translate(0 15.002)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "bricks_icon_svg__a",
    width: 32.145,
    height: 15.002,
    rx: 2.3,
    transform: "translate(0 44.998)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "bricks_icon_svg__a",
    width: 32.145,
    height: 15.002,
    rx: 2.3,
    transform: "translate(17.143)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "bricks_icon_svg__a",
    width: 32.145,
    height: 15.002,
    rx: 2.3,
    transform: "translate(17.143 29.995)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "bricks_icon_svg__a",
    width: 32.145,
    height: 15.002,
    rx: 2.3,
    transform: "translate(32.145 15.002)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "bricks_icon_svg__a",
    width: 32.145,
    height: 15.002,
    rx: 2.3,
    transform: "translate(32.145 44.998)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "bricks_icon_svg__a",
    width: 32.145,
    height: 15.002,
    rx: 2.3,
    transform: "translate(49.288 29.995)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "bricks_icon_svg__a",
    width: 32.145,
    height: 15.002,
    rx: 2.3,
    transform: "translate(64.281 44.998)"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBricksIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/bricks_icon.dcce030ba6d5d78bed6c50030d69f2f7.svg";